module.exports = __webpack_public_path__ + "static/media/Privacy and Technology Law.7e4c4192.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/Privacy and Technology Law.png
// module id = 1372
// module chunks = 1